import React, { Component } from "react";
import CreateEmployee from "../../../components/CreateEmployee/CreateEmployee";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreateEmployeeForm
Description : Componente que invoca el compoente de creación del contrato de empleados
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente CreateEmployee
================================================================================ */
class CreateEmployeeForm extends Component{
    render(){
        //console.log("Esta es: "+this.props.id)
        return(
            <CreateEmployee/>  
        )   
    }
}

export default CreateEmployeeForm;